import { usePath } from '@arnold/common';
import { FC } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Features, OrganizationQuery } from '../../generated/hooks';
import { isImportedPulserSurvey } from '../../lib/helpers';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { PATHS } from '../../screens/Surveys/types';
import { NoSurveysInfo } from '../NoSurveysInfo';
import { DashboardSection } from './DashboardSection';
import { ActiveDashboardSurveyCard } from './SurveyCards';
import { DashboardSurvey } from './utils';

type ActiveSurveysProps = {
  surveys?: DashboardSurvey[];
  enabledRespondentsCount: number;
  organization: NonNullable<OrganizationQuery['organization']>;
  isWithoutSurveys: boolean;
  onResultsClick: () => void;
};

export const ActiveSurveys: FC<ActiveSurveysProps> = ({
  surveys,
  enabledRespondentsCount,
  organization,
  isWithoutSurveys,
  onResultsClick,
}) => {
  const { t } = useTranslation('dashboard');
  const { conversationSubjectsPath } = usePath();
  const hasPulserModule = useFeatureFlag(Features.PulserModule);

  return (
    <DashboardSection
      key={'activeSurveys'}
      keyName={'active-surveys'}
      title={t('activeSurveys')}
      dataCy="dashboard-active-surveys"
      buttons={
        hasPulserModule ? undefined : (
          <div>
            <Button
              onClick={() => conversationSubjectsPath.toFunc()}
              data-icom="btn-create-new-survey"
              data-cy="btn-create-new-survey"
            >
              {t('newSurvey')}
            </Button>
          </div>
        )
      }
    >
      {surveys?.length === 0 && (
        <NoSurveysInfo
          status={PATHS.PREPARED}
          isWithoutSurveys={isWithoutSurveys}
          dataCy={isWithoutSurveys ? 'admin-before-survey' : undefined}
        />
      )}
      {surveys?.map((survey) => (
        <ActiveDashboardSurveyCard
          key={survey.id}
          survey={survey}
          organization={organization}
          enabledRespondentsCount={enabledRespondentsCount}
          onResultsClick={onResultsClick}
          hideDetail={isImportedPulserSurvey(survey)}
        />
      ))}
    </DashboardSection>
  );
};
